import { type Ref } from 'vue'

import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

export const CUSTOM_CAMPAIGNS_ME2_FLAG = 'hermes.customCampaignsMe2'

/**
 * Reactive Unleash flag gating the one-time campaign schedule send path.
 *
 * When enabled, scheduling commits `executeAt` through the dedicated
 * `/campaigns/:id/schedule` endpoint (which also hands ME2-routed brands off to
 * ME2) and refreshes the builder resource afterward. When disabled, scheduling
 * falls back to the legacy content PATCH that carries `executeAt` and never
 * calls the schedule endpoint — so the Hermes deploy can ship ahead of the
 * Olympus endpoint. Mirrors the server-side `olympus.customCampaignsMe2`
 * routing flag.
 */
export const useCustomCampaignsMe2Flag = (): Ref<boolean> =>
  useReactiveFeatureFlag(CUSTOM_CAMPAIGNS_ME2_FLAG).enabled
